import { SvgIcon } from "@/svg";
import clsx from "clsx";
import { useSidebarTooltip } from "./hooks/useSidebarTooltip";

export type FavoriteToggleProps = {
  showFavoritesOnly: boolean;
  toggleFavorites: () => void;
};

export function FavoriteToggle({ showFavoritesOnly, toggleFavorites }: FavoriteToggleProps) {
  const tooltipProps = useSidebarTooltip<HTMLDivElement>("Favorites");

  return (
    <div className="h-10 w-10" {...tooltipProps}>
      <button className="h-full w-full" onClick={toggleFavorites}>
        <div
          className={clsx(
            "h-full w-full rounded-lg flex items-center justify-center",
            showFavoritesOnly
              ? "border-2 border-sematicYellow text-sematicYellow bg-pureWhite shadow-button"
              : "bg-pureWhite text-feintGray hover:text-dark shadow-button",
          )}
        >
          <SvgIcon icon="FavoriteEmpty" />
        </div>
      </button>
    </div>
  );
}
